import { safeDefine } from '@breuni-ui/safe-define';
import { CarouselContainer } from '@breuni-ui/carousel';
import { CSSResultGroup, unsafeCSS } from 'lit';
import styles from './carousel-container.scss?inline';

export default class EntsCarouselContainer extends CarouselContainer {
  static get styles(): CSSResultGroup {
    return [super.styles, unsafeCSS(styles)].filter((style) => style !== undefined);
  }
}

safeDefine('ents-carousel-container', EntsCarouselContainer);
